import type {
  TestGroupingFeedbackSchemaType,
  TestGroupingSchemaType,
} from '@vedalib/editor/lib/brand'
import styled, { css } from 'styled-components'

import { outline } from 'components/Editor/styled/Outline'
import type { ElementFeedbackCss, ElementStyleCss } from 'services/Branding/types'

import { getAllPaddings } from '../helper'

export const AnswerWrapperStyled = styled.div<{ $styles: ElementStyleCss<TestGroupingSchemaType> }>`
  width: ${({ $styles }) => $styles.common.width};
  height: ${({ $styles }) => $styles.common.height};
  border-radius: ${({ $styles }) => $styles.common.borderRadius};
  margin: 0 auto;
  position: relative;
`

export const AnswerDragIconStyled = styled.div<{
  $styles: ElementStyleCss<TestGroupingSchemaType>
  $isDragging: boolean
}>`
  transition: 0.2s;
  width: ${({ $styles }) => $styles.dragButton.width};
  height: ${({ $styles }) => $styles.dragButton.height};
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  display: flex;
  color: ${({ $styles }) => $styles.dragButton.color};
  background-color: ${({ $styles }) => $styles.dragButton.backgroundColor};
  background-image: ${({ $styles }) => $styles.dragButton.backgroundImage};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  &:hover {
    cursor: pointer;
    ${({ $styles }) => `background-color:${$styles.hover.backgroundColor}`};
  }
`

export const PortalAnswerItemStyled = styled.div<{
  $styles: ElementStyleCss<TestGroupingSchemaType>
  $isDragging?: boolean
}>`
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  background-position: center;
  background-size: cover;

  cursor: ${({ $isDragging }) => ($isDragging ? 'grabbing' : 'pointer')};
  ${outline}
`

const correctFeedback = ($feedback: ElementFeedbackCss<TestGroupingFeedbackSchemaType>) => css`
  background-color: ${$feedback.correct.backgroundColor};
  background-image: ${$feedback.correct.backgroundImage};
`

const incorrectFeedback = ($feedback: ElementFeedbackCss<TestGroupingFeedbackSchemaType>) => css`
  background-color: ${$feedback.incorrect.backgroundColor};
  background-image: ${$feedback.incorrect.backgroundImage};
`

export const FeedbackIconStyled = styled.div<{
  $feedback: ElementFeedbackCss<TestGroupingFeedbackSchemaType>
  $isCorrect: boolean
  $styles: ElementStyleCss<TestGroupingSchemaType>
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-position: center;
  background-size: contain;
  position: absolute;
  background-repeat: no-repeat;
  top: ${({ $styles }) => getAllPaddings(String($styles.indents.padding || 0))[0]}px;
  left: ${({ $styles }) => getAllPaddings(String($styles.indents.padding || 0))[1]}px;

  width: ${({ $feedback }) => $feedback.common__var.width};
  height: ${({ $feedback }) => $feedback.common__var.height};

  ${({ $isCorrect, $feedback }) =>
    $isCorrect ? correctFeedback($feedback) : incorrectFeedback($feedback)}
`
